<template>
    <div class="contact-notes">
        <div class="user-info-content-title">{{ $t("message.notes") }}</div>
        <div class="notes">
            <div
                class="contact-note"
                v-for="note of notes"
                :key="note._id"
                @dblclick="toggleNoteOptions(note._id)"
                :class="{
                    'private-note': note.isPrivate,
                }"
            >
                <div class="contact-note-agent-avatar" v-if="note.createdUser">
                    <AgentAvatar :userID="note.createdUser._id" :size="30" />
                </div>
                <div class="contact-note-content">
                    <div class="contact-note-details">
                        <div class="contact-note-details-title">
                            <div class="contact-note-agent-name">
                                <div class="contact-note-agent-name">{{ note.createdUser.name }}</div>
                                <div
                                    class="material-icons"
                                    v-if="note.isPrivate"
                                    v-tippy="{ placement: 'left-center' }"
                                    :content="'This only showing you.'"
                                >
                                    vpn_lock
                                </div>
                            </div>
                            <div class="contact-note-more-actions">
                                <a-popover
                                    ref="myPopover"
                                    trigger="click"
                                    :visible="isPopoverVisible === note._id"
                                    @click="isPopoverVisible = note._id"
                                    placement="bottomRight"
                                    overlayClassName="contact-note-popover"
                                >
                                    <template #content>
                                        <div class="more-actions">
                                            <div class="action-button" @click="markPrivateOrPublic(note)">
                                                <div class="action-button-icon">
                                                    <div class="material-icons">attachment</div>
                                                </div>
                                                <div class="action-button-text">
                                                    {{ note.isPrivate ? "Notu Herkese Göster" : "Notu Gizle" }}
                                                </div>
                                            </div>
                                            <div class="action-button" @click="markUpdate(note)">
                                                <div class="action-button-icon">
                                                    <div class="material-icons">attachment</div>
                                                </div>
                                                <div class="action-button-text">Notu Güncelle</div>
                                            </div>
                                        </div>
                                    </template>
                                    <div v-if="!isNoteOpened(note)" class="material-icons">more_vert</div>
                                </a-popover>
                                <div
                                    v-if="isNoteOpened(note)"
                                    @click.stop="toggleNoteOptions(note._id)"
                                    class="material-icons"
                                >
                                    close
                                </div>
                            </div>
                        </div>
                        <div class="contact-notes-form" v-if="updatingNote && updatingNote._id === note._id">
                            <a-textarea
                                class="non-resizable"
                                v-model="description"
                                :auto-size="{ minRows: 2, maxRows: 10 }"
                                style="width: 95%"
                            />
                            <div class="contact-notes-form-actions">
                                <div></div>
                                <div class="contact-notes-update-buttons">
                                    <div class="note-button note-update-cancel" @click="updatingNote = null">
                                        Vazgeç
                                    </div>
                                    <div class="note-button note-update-ok" @click="makeUpdateNote">Güncelle</div>
                                </div>
                            </div>
                        </div>
                        <div class="contact-note-details-description" v-else>
                            {{ note.description }}
                        </div>
                        <div class="contact-note-details-date">
                            {{
                                note.updatedAt
                                    ? new Date(note.updatedAt).toLocaleDateString() +
                                      " - " +
                                      new Date(note.updatedAt).toLocaleTimeString("tr-TR", { hour12: false })
                                    : new Date(note.createdAt).toLocaleDateString() +
                                      " - " +
                                      new Date(note.createdAt).toLocaleTimeString("tr-TR", { hour12: false })
                            }}
                        </div>
                    </div>
                    <div class="note-action-button" v-if="isNoteOpened(note)">
                        <div v-if="!deleteMode" class="note-update-button note-button" @click="markUpdate(note)">
                            Düzenle
                        </div>
                        <div v-if="!deleteMode" class="note-delete-button note-button" @click="deleteMode = true">
                            Sil
                        </div>

                        <div
                            v-if="deleteMode"
                            class="note-update-button note-button"
                            @click="toggleNoteOptions(note._id)"
                        >
                            Vazgeç
                        </div>
                        <div v-if="deleteMode" class="note-delete-button note-button" @click="deleteNote(note)">
                            Sil
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!updatingNote" class="fixed-bottom-area" :class="{ expanded: isExpanded }" @click="toggleExpand">
            <div class="fixed-bottom-area-header">
                <div class="material-icons">draw</div>
                <span class="fixed-bottom-area-title">{{ $t("message.addNote") }}</span>
            </div>
            <div class="fixed-bottom-area-content">
                <textarea
                    v-model="description"
                    placeholder="Kullanıcı hakkında not ekle"
                    class="non-resizable"
                ></textarea>
            </div>
            <div class="fixed-bottom-area-footer">
                <div class="contact-notes-form-actions">
                    <a-checkbox v-model="isPrivate"> Private Note</a-checkbox>
                    <div class="contact-notes-form-actions-buttons">
                        <div class="custom-submit-button" @click="submitForm">
                            <span>Gönder</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import SupsisButton from "../../../views/Pages/Settings/components/SupsisButton.vue";
import AgentAvatar from "../../common/AgentAvatar.vue";

export default {
    name: "ContactNotes",
    components: { AgentAvatar, SupsisButton },
    props: {
        visitorId: {
            type: String,
            required: true,
        },
    },
    data: () => ({
        deleteMode: false,
        notes: [],
        isPrivate: false,
        description: null,
        isCreatingActive: false,
        updatingNote: null,
        isPopoverVisible: false,
        isExpanded: false,
        openedNoteId: null,
        listeners: [],
    }),
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
    },
    methods: {
        ...mapActions({
            createNote: "visitor/createVisitorNote",
            updateNote: "visitor/updateVisitorNote",
            getNotes: "visitor/getVisitorNotes",
            deleteVisitorNote: "visitor/deleteVisitorNote",
        }),
        isNoteOpened(note) {
            return this.openedNoteId === note._id;
        },
        toggleNoteOptions(noteId) {
            this.isPopoverVisible = false;
            this.openedNoteId = this.openedNoteId === noteId ? null : noteId;
            this.deleteMode = false;
            if (this.openedNoteId) {
                this.updatingNote = null;
            }
        },
        closeNoteOptions() {
            this.isPopoverVisible = false;
            this.openedNoteId = null;
        },
        submitForm() {
            this.isPopoverVisible = false;
            this.createNote({
                visitorId: this.visitorId,
                payload: {
                    isPrivate: this.isPrivate,
                    description: this.description,
                },
            }).then((body) => {
                this.notes = [body, ...this.notes]
                    .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
                    .sort((a, b) => b.isPrivate - a.isPrivate);
                this.isPrivate = false;
                this.description = null;
            });
        },
        markPrivateOrPublic(note) {
            this.isPopoverVisible = false;
            this.updateNote({
                visitorId: this.visitorId,
                noteId: note._id,
                payload: {
                    isPrivate: !note.isPrivate,
                },
            }).then((body) => {
                // isPrivate önlerde olacak şekilde güncelleme yapılacak ve sonrasında private önde olacak şekilde tarihe göre sıralanacak
                this.notes = this.notes
                    .map((n) => {
                        if (note._id === n._id) n.isPrivate = !n.isPrivate;
                        return n;
                    })
                    .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
                    .sort((a, b) => b.isPrivate - a.isPrivate);
            });
        },
        markUpdate(note) {
            this.closeNoteOptions();
            this.isPopoverVisible = false;
            this.updatingNote = note;
            this.description = note.description;
        },
        deleteNote(note) {
            this.notes = this.notes.filter((n) => n._id !== note._id);
        },
        makeUpdateNote() {
            this.isPopoverVisible = false;
            this.updateNote({
                visitorId: this.visitorId,
                noteId: this.updatingNote._id,
                payload: {
                    ...this.updatingNote,
                    description: this.description,
                },
            }).then((body) => {
                this.notes = this.notes
                    .map((n) => {
                        if (this.updatingNote._id === n._id) n.description = this.description;
                        return n;
                    })
                    .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
                    .sort((a, b) => b.isPrivate - a.isPrivate);
                this.updatingNote = null;
            });
        },
        toggleExpand() {
            this.isExpanded = !this.isExpanded;
        },
        init() {
            this.listeners.forEach((listener) => listener());
            this.getNotes(this.visitorId).then((notes) => {
                this.notes = notes;
            });
            const popover = this.$refs.myPopover;

            const callback = (e) => {
                if (popover) {
                    if (popover.contains(e.target)) {
                        this.isPopoverVisible = false;
                    }
                }
            };
            document.addEventListener("click", callback);
            this.listeners.push(() => {
                document.removeEventListener("click", callback);
            });
        },
    },
    mounted() {
        this.init();
    },
    beforeDestroy() {
        this.listeners.forEach((listener) => listener());
    },
    watch: {
        visitorId(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.init();
            }
        },
    },
};
</script>
<style lang="scss">
.note-button {
    border-radius: 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
}
.note-delete-button {
    width: 30%;
    background-color: #ff5050;
    color: white;
}
.note-update-button {
    width: 60%;
    background-color: #f1f4f7;
    color: #647491;
}
.contact-notes-update-buttons {
    width: 95%;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    align-items: center;
    height: 30px;
    .note-update-ok {
        height: 100%;
        background-color: #22272d;
        color: white;
        width: 30%;
        margin-right: 15px;
    }
    .note-update-cancel {
        height: 100%;
        background-color: #f1f4f7;
        color: #647491;
        width: 30%;
    }
}
.contact-note-popover {
    .ant-popover-arrow {
        display: none !important;
    }

    .ant-popover-inner-content {
        box-shadow: none !important;
        border: 1px solid var(--border-neutral-default);
        border-radius: 4px;
        padding: 0 !important;

        .more-actions {
            overflow: hidden;

            :not(:last-child).action-button {
                border-bottom: 1px solid var(--border-neutral-default);
            }

            .action-button {
                display: flex;
                align-items: center;
                padding: 4px 10px;
                gap: 4px;
                cursor: pointer;

                &:hover {
                    background: #22272d;
                    border-radius: 4px;

                    .action-button-icon {
                        .material-icons {
                            color: white;
                        }
                    }

                    .action-button-text {
                        color: white;
                    }
                }

                &-icon {
                    line-height: 0;

                    .material-icons {
                        font-size: 18px;
                    }
                }

                &-text {
                    font-size: 16px;
                }
            }
        }
    }
}
.contact-notes {
    display: flex;
    flex-direction: column;
    gap: 30px;
    height: 100%;
    align-items: center;
    .user-info-content-title {
        width: 100%;
        padding: 10px 10px 0 10px;
        display: flex;
        justify-content: space-between;
    }
    .fixed-bottom-area {
        position: relative;
        border-top: 1px solid #f1f4f7;
        bottom: 0;
        left: 0;
        width: 100%;
        background: #ffffff;
        padding: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        z-index: 1000;
        cursor: pointer;
        .fixed-bottom-area-footer {
            display: flex;
            justify-content: space-between;
            width: 100%;
            align-items: center;
            .custom-submit-button {
                background: black;
                width: 60px;
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 4px;
                cursor: pointer;
                span {
                    color: white;
                    font-size: 14px;
                }
            }
        }
        .fixed-bottom-area-content {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 10px;
        }
        textarea {
            width: 100%;
            padding: 5px;
            border: 1px solid #ccc;
            border-radius: 4px;
            resize: none;
            background-color: #f1f4f7;
        }
        .fixed-bottom-area-header {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            gap: 20px;
            width: 100%;

            .material-icons {
                font-size: 20px;
                fill: transparent !important;
            }
            .fixed-bottom-area-title {
                font-size: 16px;
                font-weight: bold;
            }
        }
    }

    &-form {
        display: flex;
        flex-direction: column;
        gap: 4px;

        textarea.ant-input:hover,
        textarea.ant-input:focus {
            border-color: #22272d !important;
            box-shadow: none !important;
        }

        &-actions {
            display: flex;
            justify-content: space-between;
            width: 100%;

            .ant-checkbox-wrapper:hover .ant-checkbox-inner,
            .ant-checkbox:hover .ant-checkbox-inner,
            .ant-checkbox-input:focus + .ant-checkbox-inner,
            .ant-checkbox-checked .ant-checkbox-inner,
            .ant-checkbox-checked::after {
                border-color: #22272d !important;
            }

            .ant-checkbox-checked .ant-checkbox-inner {
                background: #22272d !important;
            }

            &-buttons {
                display: flex;
                align-items: center;
                gap: 4px;

                &-item {
                    background: #22272d;
                    width: 25px;
                    height: 25px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 3px;
                    line-height: 0;
                    cursor: pointer;

                    .material-icons {
                        user-select: none;
                        color: white;
                        font-size: 18px;
                    }
                }
            }
        }
    }

    .notes {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        flex-direction: column;
        gap: 10px;
        width: 100%;
        overflow: auto;
        padding: 0 10px;
        &::-webkit-scrollbar {
            height: 0;
            width: 0;
            display: none;
        }
        &:hover {
            &::-webkit-scrollbar {
                width: 3px;
                display: block;
            }
        }

        .contact-note {
            display: flex;
            align-items: flex-start;
            gap: 8px;
            padding: 8px;

            &.private-note {
                background-color: rgb(253, 255, 104); // todo set to attribute
            }
            .contact-note-content {
                display: flex;
                flex-direction: column;
                gap: 5px;
                width: 100%;
                .contact-note-details-date {
                    font-size: 12px;
                    color: #647491;
                }
            }
            .note-action-button {
                display: flex;
                justify-content: flex-start;
                width: 100%;
                gap: 8px;
                height: 30px;
            }
            .note-update-cancel {
            }
            .note-update-ok {
            }

            &-agent-avatar {
                width: 30px;
                height: 30px;
                border-radius: 30px;
            }

            &-details {
                display: flex;
                flex-direction: column;
                gap: 3px;
                width: 100%;

                &-title {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 100%;

                    .contact-note-agent-name {
                        font-size: 16px;
                        display: flex;
                        align-items: center;
                        font-weight: bold;
                        gap: 4px;
                        .material-icons {
                            font-size: 16px;
                            line-height: 0;
                            user-select: none;
                        }
                    }
                    .contact-note-more-actions {
                        .material-icons {
                            cursor: pointer;
                            width: 20px;
                            height: 20px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 16px;
                        }
                    }
                }

                &-description {
                    border-radius: 4px;
                    max-height: 60px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
            }
        }
    }
}
.non-resizable {
    resize: none !important;
}
</style>
